// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThreeColumnList-module--wrapper--9fxUI","list":"ThreeColumnList-module--list--28wF1"};